"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _AnswerOverviewStyle = _interopRequireDefault(require("./../css/AnswerOverviewStyle"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AnswerOverview = function AnswerOverview(_ref) {
  var scenario = _ref.scenario,
      viewData = _ref.viewData,
      index = _ref.index,
      reviewAnswersView = _ref.reviewAnswersView,
      deleteScenario = _ref.deleteScenario,
      template = _ref.template;

  var editScenario = function editScenario() {
    typeof dataLayer != "undefined" ? dataLayer.push({
      event: "GAevent",
      eventCategory: "All Link & Button Clicks",
      eventAction: "Scenario edit",
      eventLabel: "".concat(scenario.title.html.html.replace(/<.*?>/g, "").trim())
    }) : null;
  };

  return /*#__PURE__*/_react["default"].createElement(_AnswerOverviewStyle["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "answer-overview"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "answer-overview-header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "answer-overview-header__actions"
  }, /*#__PURE__*/_react["default"].createElement("p", null, index ? "".concat(viewData.situationNumber.html.html).concat(index + 1) : "".concat(viewData.situationNumber.html.html, " 1")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "answer-overview-button-wrapper edit-icon"
  }, /*#__PURE__*/_react["default"].createElement("div", null, viewData.editButton && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    onClick: function onClick(e) {
      return editScenario(e, scenario);
    },
    to: {
      pathname: "scenario-".concat(scenario.scenarioIndex),
      state: {
        reviewAnswersView: reviewAnswersView ? true : false
      }
    }
  })), deleteScenario && /*#__PURE__*/_react["default"].createElement("button", {
    className: "answer-overview-remove",
    type: "button",
    onClick: function onClick(e) {
      return deleteScenario(e, scenario.scenarioIndex, scenario);
    }
  }))), scenario.title && !template && /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: scenario.title.html.html
    },
    title: scenario.title.html.html.length > 35 ? scenario.title.html.html : ""
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "answer-overview-image ".concat(template ? "template" : "")
  }, scenario.summaryImage && /*#__PURE__*/_react["default"].createElement("img", {
    src: scenario.summaryImage.image.src
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "answer-overview-footer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "answer-overview-quotation"
  }), !template && /*#__PURE__*/_react["default"].createElement("div", {
    className: "answer-overview-description"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, viewData.personalDescription.html.html), /*#__PURE__*/_react["default"].createElement("p", null, scenario.userScenarioDescription)))));
};

var _default = AnswerOverview;
exports["default"] = _default;